// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__CUicX","left":"InfoRow_left__2mGKR"};